import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setActiveLanguage, getActiveLanguage} from 'react-localize-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import {store} from '../../index';
import {VERSION} from '../../config/Config';
import {getTranslate} from "react-localize-redux/lib/index";

class LanguageBar extends Component {

    renderLanguage() {
        return this.props.languageCodes.map((lang, index) => {
             if (lang !== this.props.currentLanguage) {
                 return (
                     <li key={lang}>
                         <a href="#" onClick={this.changeLanguage.bind(this, lang)}>{lang}</a>
                    </li>
                 );
             }
        });
    }

    changeLanguage(lang) {
        store.dispatch(setActiveLanguage(lang));
        return;
    }

    togglePrices() {
        this.props.togglePrices();
        return;
    }

    render() {
        return (
            <div className='language-bar col m2 center-align'>
                <a className='dropdown-button' href='#' data-activates='dropdown-price'>-</a>
                <ul id='dropdown-price' className='dropdown-content'>
                    <li key='showPrices'>
                        <a href="#" onClick={this.togglePrices.bind(this)}>{!this.props.showPrices ? this.props.translate('showPrices') : this.props.translate('hidePrices') }</a>
                   </li>
                </ul>
                <span className='version'>{VERSION}</span>
                <a className='dropdown-button' href='#' data-activates='dropdown-lang'>{this.props.currentLanguage.toUpperCase()}</a>
                <ul id='dropdown-lang' className='dropdown-content'>
                    {this.renderLanguage(this.props.languageCodes)}
                </ul>
            </div>
        );
    }
}


/**
 * Prop types
 * @type {{tempDetails: *}}
 */
LanguageBar.propTypes = {
    currentLanguage: PropTypes.string,
    showPrices:  PropTypes.bool,
    togglePrices: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        currentLanguage: getActiveLanguage(state.locale).code,
        showPrices: state.showPrices,
        translate:  getTranslate(state.locale),
    }
}


export default connect(mapStateToProps, actions)(LanguageBar);



// WEBPACK FOOTER //
// ./src/components/language/LanguageBar.js